import { Observable } from 'rxjs';
import { StorageParameters } from '../storage.service';
import { ApiBase } from './api.base';
import { AuctionItem } from '../../models/auction-item';
import { Bid } from '../../models/bid';
import { Auction } from '../../models/auction';
import { RepeatOffender } from '@admin-shared/models/repeat-offender';

export class RepeatOffendersApi extends ApiBase {
  model = 'admin/repeat-offender';

  public addToList(data?: RepeatOffender): Observable<RepeatOffender> {
    return this.http.post<RepeatOffender>(this.buildUrl('add-to-list'), data, {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(StorageParameters.AccessTokenId),
      }),
    });
  }

  public removeFromList(profileId: string, foundationId: string): Observable<{ success: boolean }> {
    return this.http.post<{ success: boolean }>(
      this.buildUrl('remove-from-list'),
      { profileId, foundationId },
      {
        headers: this.setHeaders({
          Authorization: this.getStorage().getItem(StorageParameters.AccessTokenId),
        }),
      }
    );
  }

  public getFoundationRepeatOffenders(id: string): Observable<RepeatOffender[]> {
    return this.http.get<RepeatOffender[]>(this.buildUrl(id, 'foundation-repeat-offenders'), {
      headers: this.setHeaders({
        Authorization: this.getStorage().getItem(StorageParameters.AccessTokenId),
      }),
    });
  }
}
